/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-11-30 22:40:29
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-11-30 22:47:16
 * @FilePath: \hope-enroll\src\utils\observes.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const activeIntersectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 使用 HTMLElement 类型以确保具有 dataset 属性
          const targetElement = entry.target as HTMLElement;
          targetElement.classList.add(targetElement.dataset.active || "active");
        } else {
          // 同样，使用 HTMLElement 类型
          const targetElement = entry.target as HTMLElement;
          targetElement.classList.remove(targetElement.dataset.active || "active");
        }
      });
    }
  );

  